import produce from "immer";

export const isObject = (val: any) => {
  return typeof val === "object" && val !== null;
};

export const filterFalsyData = (data: any, excludeEmptyString = false, excludeEmptyArray = false) => {
  let filteredData = {};

  for (const key in data) {
    if (
      (data[key] && data[key]?.length > 0) ||
      (excludeEmptyString && data[key] === "") ||
      (excludeEmptyArray && data[key]?.length === 0)
    ) {
      filteredData[key] = data[key];
    }
  }

  return filteredData;
};

export const filterUndefinedNull = (obj: any) => {
  return Object.entries(obj).reduce((a, [k, v]) => (v == null ? a : ((a[k] = v), a)), {});
};

export const convertObjectToFormData = (data: any) => {
  const formData = new FormData();

  Object.keys(data).forEach((key) => formData.append(key, data[key]));

  return formData;
};

export const filterEmptyArray = (data: any) => {
  let filteredData = {};

  for (const key in data) {
    if (!Array.isArray(data[key]) || data[key].length > 0) {
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      filteredData[key] = data[key];
    }
  }

  return filteredData;
};

export const isEmpty = (obj: any) => {
  return obj && Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype;
};

export const getLength = (obj = {}) => {
  return Object.keys(obj)?.length;
};

export const changeKeyName = (obj: any, oldKey: any, newKey: any) => {
  obj[newKey] = obj[oldKey];
  delete obj[oldKey];
};

export const countKeyDifferences = (obj1: any, obj2: any) => {};

export const deepCopy = (obj: any) => produce(obj, (draft: any) => draft);

//Input: ["cat", "mouse", "rabbit"]
//Output: {cat: "cat", mouse: "mouse", rabbit: "rabbit"}
export const generateObjectFromArray = (arr = []) =>
  arr.reduce(
    (acc, curr) => ({
      ...acc,
      [curr]: curr,
    }),
    {}
  );
